import { useParams, Navigate } from "react-router-dom";

import { usePropertyListingQuery } from "@gql";
import { PropertyListingPrice } from "@components";
import { PropertyListingImages } from "@components/property_listing_images";

import { ListingAgent } from "./ListingAgent";
import { Office } from "./Office";
import { Details } from "./Details";
import * as styles from "./PropertyListing.styles";

const PropertyListing = () => {
  const { slug } = useParams();
  const { loading, data, error } = usePropertyListingQuery({
    variables: { slug: slug || "" },
    skip: !slug,
  });

  if (loading) return null;

  if (error) {
    return <Navigate to="/" replace />;
  }

  const {
    id,
    images,
    addressLine1,
    unitNumber,
    city,
    province,
    postalCode,
    listingAgent,
    moreInformationLink,
  } = data?.propertyListing ?? {};

  const renderMoreInfo = () => {
    if (!moreInformationLink) return null;

    return (
      <a css={styles.moreInfo} href={moreInformationLink}>
        More Info
      </a>
    );
  };

  const renderListingAgent = () => {
    if (!listingAgent) return null;

    return <ListingAgent listingAgent={listingAgent} />;
  };

  const renderOffice = () => {
    if (!listingAgent?.office) return null;

    return <Office office={listingAgent.office} />;
  };

  if (!data?.propertyListing) return null;

  return (
    <div data-testid="propertyListing" css={styles.propertyListing}>
      <div css={styles.container}>
        <PropertyListingImages images={images} propertyListingId={id} />
        <div css={styles.addressPriceContainer}>
          <div css={styles.addressPrice}>
            <PropertyListingPrice propertyListing={data?.propertyListing} />
          </div>
          <h1 css={[styles.addressPrice, styles.adddress]}>
            <address>
              {addressLine1}
              {", "}
              {unitNumber ? `Unit: ${unitNumber}` : ""}
              {city}, {province}
              {", "}
              {postalCode}
            </address>
          </h1>
          {renderMoreInfo()}
        </div>
        <div css={styles.detailsContainer} className="listing-agent-and-property-details-container">
          <div css={styles.agentAndOfficeDetails} className="listing-agent-and-office-details">
            {renderListingAgent()}
            {renderOffice()}
          </div>
          <Details propertyListing={data?.propertyListing} />
        </div>
        <div className="clear" />
      </div>
    </div>
  );
};

export { PropertyListing };
